import * as Routes from '../../scripts/routes';

do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  ConsultarProcessoController = ($http) ->
    vm = @

    ### CONSTANTS ###
    vm.ANOS = [ Array(20).keys()... ].map((i) => (2010 + i).toString())

    ### VARIABLES VIEW MODEL ###
    vm.numeroSearch = ''
    vm.justificativa = ''

    ### VARIAVEIS PRIVATE ###

    ### WATCHES ###

    # INIT SETUP
    init = () =>
      return

    ### METHODS PRIVATE ###


    ### METHODS VIEW MODEL ###

    vm.validateNumeroSearch = ->
      [numero, ano] = vm.numeroSearch.split("/")
      validate_ok = !!(numero && ano && numero.length > 6 && ano.length == 4 && vm.ANOS.includes(ano))

      return validate_ok

    vm.consultar = ->
      Turbolinks.visit(Routes.consultar_processo_path(vm.numeroSearch.replace('/', '_'))) if vm.validateNumeroSearch()

      return

    vm.inserirJustificativa = ->
      Swal.fire("Erro!", "teste", "error")
      vm.justificativa = await Swal.fire(
        input: "textarea",
        inputLabel: "Justificativa de Download do Processo " + vm.numeroSearch,
        confirmButtonText: "Baixar!",
        confirmButtonColor: "#FFCC00",
        inputPlaceholder: "Insira sua justificativa aqui...",
        inputAttributes: {
          "aria-label": "Insira sua justificativa aqui",
          "required": true
        },
        showCancelButton: true
      )
      if vm.justificativa.value != '' && vm.justificativa.value != undefined
        proc = vm.numeroSearch.replace('/', '_')
        url = "/processos/materializar/"+proc+"?download_file=true&justificativa="+encodeURIComponent(vm.justificativa.value)
        window.location.href = url
        # Turbolinks.visit(Routes.materializar_processo_path(vm.numeroSearch.replace('/', '_'), {download_file: true, justificativa: vm.justificativa.value}))
      else
        Swal.fire("Atenção!", "É necessário preencher a justificativa para fazer o Download do Processo", "error")
      return

    vm.atualizarVisualizacao = (href) ->
      msg = """
      <div style="text-align: left;">
      Sistema informa:<br/>
      Você está prestes a iniciar um novo processo de montagem, isto pode
      demorar, pois:<br/>
      <br/>
      1 - Virão a última versão dos documentos anexados;<br/>
      2 - Virão a última versão dos documentos substituidos;<br/>
      3 - Virão documentos com a versão contendo todas as assinaturas já realizadas;<br/>
      4 - Ocultará todos os documentos cancelados.<br/>
      </div>
      """
      Swal.fire({
        title: 'Você tem certeza disso?',
        html: msg,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCancelButton: true,
        confirmButtonColor: '#199B91'
      }).then (result) ->
        location.href = href if result?.isConfirmed
        return
      return

    # CALL INIT SETUP
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'ConsultarProcessoController', ConsultarProcessoController

  # ANGULAR INJECT DEPENDENCIES
  ConsultarProcessoController.$inject = ['$http']

  # END BLOCK SCRIPT
  return
